import put from './put';
import get from './get';
import del from './delete';
import activity from './activity';
import impersonate from './impersonate';
import unlock from './unlock';

export default { put, get, del, activity, impersonate, unlock };
